import moment from 'moment';

class GraphUtility {
    static formatTicks(tick, start, end) {
        const startMoment = moment.unix(start);
        const endMoment = moment.unix(end);
        const diff = Math.floor(endMoment.diff(startMoment, "hours"));
    
        let formatString = undefined;
        if (diff <= 6) {
          formatString = "LT";
        } else if (diff <= 24) {
          formatString = moment().format("LT").length > 5 ? "h A" : "HH";
        } else if (diff <= 72) {
          formatString = "L LT";
        } else {
          formatString = "L";
        }
    
        return moment.unix(tick).utc().format(formatString);
      }

    static calculateTicks(start, end) {
        const startMoment = moment.unix(start);
        const endMoment = moment.unix(end);
        const diff = Math.floor(endMoment.diff(startMoment, "hours"));
    
        let tickInterval;
        let firstTick;
        let lastTick;
    
        if (diff <= 6) {
          tickInterval = 15 * 60; // 15 minute intervals
          firstTick = Math.ceil(start / 60 / 15) * 15 * 60;
          lastTick = Math.floor(end / 60 / 15) * 15 * 60;
        } else if (diff <= 12) {
          tickInterval = 60 * 60; // 1 hour intervals
          firstTick = Math.ceil(start / 60 / 60) * 60 * 60;
          lastTick = Math.floor(end / 60 / 60) * 60 * 60;
        } else if (diff <= 24) {
          tickInterval = 2 * 60 * 60; // 2 hour intervals
          firstTick = Math.ceil(start / 60 / 60) * 60 * 60;
          lastTick = Math.floor(end / 60 / 60 ) * 60 * 60;
        } else if (diff <= 72) {
          tickInterval = 4 * 60 * 60; // 4 hour intervals
          firstTick = Math.ceil(start / 60 / 60) * 60 * 60;
          lastTick = Math.floor(end / 60 / 60 ) * 60 * 60;
        } else {
          tickInterval = 24 * 60 * 60; // 1 day intervals
          firstTick = Math.ceil(start / 60 / 60) * 60 * 60;
          lastTick = Math.floor(end / 60 / 60) * 60 * 60;
        }
    
        // Calculate ticks for this interval
        let ticks = [];
        for (let i = firstTick; i <= lastTick; i = i + tickInterval) {
          ticks.push(i);
        }
    
        return ticks;
      } 
}

export default GraphUtility;